import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./components/LandingPage";
import LpCTA from "./components/LpCTA";
import ContactPage from "./components/ContactPage";
import XMLDownload from "./components/XMLDownload";
import HelpPage from "./components/HelpPage";
import TermoUso from "./components/TermoUso";

function App() {
  React.useEffect(() => {
    const hasHash = window.location.hash.includes("#/");
    const params = new URLSearchParams(window.location.search);

    if (!hasHash && params.get("codigo")) {
      const codigo = params.get("codigo");
      window.location.replace(`/#/ajuda?codigo=${codigo}`);
    }
  }, []);

  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/lp-cta" element={<LpCTA />} />
          <Route path="/contato" element={<ContactPage />} />
          <Route path="/xml" element={<XMLDownload />} />
          <Route path="/ajuda" element={<HelpPage />} />
          <Route path="/termouso" element={<TermoUso />} />
        </Routes>
        <Toaster position="top-right" />
      </HashRouter>
    </div>
  );
}

export default App;
